module.exports = __webpack_public_path__ + "static/media/backnuevo.c06e5d22.png";